/*
 * Project: BookingEngine
 * Module: components/booking/mybooking/BookingDetailHotel.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Btn from '../../atoms/btn';
import BtnClose from '../../atoms/btn/btnClose';
import PopUp from '../../atoms/popup';
import { sendBookingMessage } from '../../../../actions/Booking';
import Loading from '../../atoms/loading';

class BookingDetailHotel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'initial',
      contactMessage: '',
      showModal: false,
    };
  }

  resetForm = () => {
    this.setState({
      status: 'initial',
      contactMessage: '',
    });
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  contactFormSend = (ev) => {
    this.setState({
      status: 'loading',
    });
    this.props.sendBookingMessage(ev).then((response) => {
      this.setState({
        status: response.locator ? 'success' : 'error',
        contactMessage: '',
      });
    }).catch(() => {
      this.setState({
        status: 'error',
      });
    });
  };

  // **** RENDER // **** //
  popupForm() {
    const { email, locator } = this.props;
    const message = this.state.contactMessage;
    return (
      <form className="flex flex-col" onSubmit={(e) => { e.preventDefault(); }}>
        <div className="flex justify-between">
        <label className="mb-1">{this.context.t('Write a message to the hotel')}</label>
        <BtnClose className="self-end mb-auto"
            onClick={() => this.toggleModal()}
          />
        </div>
        <textarea
          /* eslint-disable max-len */
          className="bg-gray-100 focus:bg-opacity-50 focus:outline-none focus:shadow-inner p-1 transition duration-500 ease-in-out"
          /* eslint-enable max-len */
          placeholder={this.context.t('I would like to know...')}
          rows={4}
          value={this.state.contactMessage}
          onChange={this.onContactMessageChange}
        />
        <div className="flex mt-2">
          <Btn
            variant="primary"
            onClick={() => this.contactFormSend({ locator, email, message })}
          >
            {this.context.t('Submit')}
          </Btn>
        </div>
      </form>
    );
  }

  popupError() {
    return (
      <div className="text-red-500">
        <p className="py-2">
          {this.context.t('Your message could not be sent to the hotel')}
        </p>
        <div className="flex mt-2">
        <Btn
            variant="primary"
            onClick={() => this.resetForm()}
          >
          {this.context.t('Try again')}
          </Btn>
          </div>
      </div>
    );
  }

  PopupModule() {
    const { status } = this.state;
    switch (status) {
      case 'loading':
        return (<Loading className="w-full">{this.context.t('Loading')}...</Loading>);
      case 'success':
        return (<div className="text-green-500">{this.context.t('Your message was sent correctly')}</div>);
      case 'error':
        return this.popupError();
      case 'initial':
      default:
        return this.popupForm();
    }
  }

  onContactMessageChange = (e) => {
    this.setState({ contactMessage: e.target.value });
  };

  render() {
    const { showModal } = this.state;
    const estilo = {
      color: '#0066cc',
      fontSize: '0.95rem',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
    };
    return (
      <div className="relative z-10 py-1" style={estilo}>
      <Btn onClick={() => this.toggleModal()} icon="chat" iconClassName="text-primary">
         {this.context.t('Contact the hotel')}
      </Btn>
      <PopUp show={showModal} className="w-56">
      {this.PopupModule()}
      </PopUp>
      </div>

    );
  }
}

BookingDetailHotel.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

BookingDetailHotel.propTypes = {
  email: PropTypes.string.isRequired,
  locator: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
});

const mapDispatchToProps = (dispatch) => ({
  sendBookingMessage: (payload) => dispatch(sendBookingMessage(payload.locator, payload.email, payload.message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingDetailHotel);
